// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '../../comp/text';
import choose_url from './choose.png';
import complete_url from './complete.png';
import get_paid_url from './get_paid.svg?url';
import * as cns from './ads.module.less';

const SLIDES = [{
    poster: choose_url,
    name: 'Select an offer',
    description: `Explore a variety of tasks available on the Earn page.
        We showcase top offers from companies looking to promote their apps,
        games, and products.`,
}, {
    poster: complete_url,
    name: 'Complete the task',
    description: `It's super easy! Most offers take less than 10 minutes
        and have already helped thousands of people
        earn money - don't miss out!`,
}, {
    poster: get_paid_url,
    name: 'Receive payment',
    description: `Earn cash for every task you complete,
        cash out and enjoy your free money!`,
}];

function Ad({data, index}){
    return <li className={cns.ad}>
      <img className={cns.poster} src={data.poster} loading="lazy"/>
      <Text.xxl className={cns.name} bold>{index+1}. {data.name}</Text.xxl>
      <Text.l className={cns.desc} secondary>{data.description}</Text.l>
    </li>;
}

export function Ads({className}){
    return <div className={cn(cns.root, className)}>
      <Text.xxl secondary>Looking to Earn Easy Cash?</Text.xxl>
      <Text.xxxl bold>Here's how</Text.xxxl>
      <ul className={cns.list}>
        {SLIDES.map((d, index)=><Ad key={d.name} data={d} index={index}/>)}
      </ul>
    </div>;
}
